import { useState, useEffect } from 'react';
import useModal, { MODAL_LG, MODAL_md } from '../../../../theme/Component/hooks/useModal';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _ProductionOrder, _single } from '../../../../../core/services/dataBean/EntityCatalog';
import usePaginator from '../../../../theme/Component/usePaginator';
import { Modal } from '../../../../theme/Component/Modal';
import { BasicTable, MASK_NUMBER } from '../../../../theme/Component/BasicTable';
import { AccountEditor } from '../../../../editor/AccountEditor';
import { YearSelector } from '../../../../../core/shared/inputs/YearSelector';
import { MonthConstantsEditor } from '../../../../RemoteAbstractAction/editors/MonthConstantsEditor';
import { SelectProject } from '../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject';
import { SelectManufacturingStandars } from '../../../ManufacturingStandars/SelectManufacturingStandars';
import { SelectAttentionOffice } from '../../../ProductionOrder/Components/SelectAttentionOffice';
import { SelectStoreEditor } from '../../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor';
import { SelectProductionOrderStateConstants } from '../../../ProductionOrder/Components/SelectProductionOrderStateConstants';
import { BasicButton } from '../../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const CatalogForRawMaterialeditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {
    const paginador = usePaginator();
    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_ProductionOrder);
    const [id, setID] = useState(null);
    const [registers, setRegisters] = useState<number>(15)
    const modal = useModal("Solicitud", MODAL_LG);
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        IDProject: NaN,
        IDManufacturingStandart: NaN,
        IDAttentionOffice: NaN,
        IDStore: NaN,
    })

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        instance.getProductionOrderCatalogForRawMaterial(form.IDAccount, form.Year, form.MonthVigency, form.IDProject, form.IDManufacturingStandart, form.IDAttentionOffice, form.IDStore, paginador.page, registers).then(
            (resp) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)

                    setLista(resp.List)
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDRawMaterialRequest == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const head = [
        { title: 'No. Solicitud Materia Prima', property: 'IDRawMaterialRequest', visible: true },
        { title: 'No. Orden de Producción', property: 'IDProductionOrder', visible: true },
        { title: 'Fecha de la Orden de Producción', property: 'ProductionOrderDate', visible: true },
        { title: 'Centro de Fabricación', property: 'IDAttentionOffice', visible: true },
        // { title: 'Fecha Inicio', property: 'InitDate', visible: true },
        // { title: 'Fecha Fin', property: 'UptoDate', visible: true },
        { title: 'Tipo de Solicitud', property: 'TypeName', visible: true },
        { title: 'No Orden del Cliente', property: 'ExternalRequestReference', visible: true },
        { title: 'Cliente/Solicitante', property: 'ContractName', visible: true },
        { title: 'Estandard de Fabricación', property: 'IDManufacturingStardard', visible: true },
        { title: 'Producto a Producir', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Proyecto', property: 'IDProject', visible: true },
        { title: 'Cantidad a Producir', property: 'Quantity', visible: true },
        // { title: 'Estado', property: 'State', visible: true },
        { title: 'Estado de la Operación', property: 'OrderStateName', visible: true },
        { title: 'Documento Orden de Producción', property: 'POConsecutive', visible: true },
        { title: 'Documento Factura de Venta', property: 'UBLInvoiceConsecutive', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Solicitudes de Material de Ordenes de Producción"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <AccountEditor idAccount={null} label="Cliente" onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Año/Vigencia</label>
                        <YearSelector tittle=" " onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Mes</label>
                        <MonthConstantsEditor idSelect={form.MonthVigency} onChange={(e) => { setForm({ ...form, "MonthVigency": e }) }} label=" " name="" />
                    </div>
                    <div className="col-md-6">
                        <label>Proyecto</label>
                        <SelectProject idSelector={form.IDProject} onChange={(e) => { setForm({ ...form, "IDProject": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectManufacturingStandars idSelector={form.IDManufacturingStandart} onChange={(e) => { setForm({ ...form, "IDManufacturingStandart": e }) }} label="Estandard de Fabricación" />
                    </div>
                    <div className="col-md-6">
                        <SelectAttentionOffice idSelector={form.IDAttentionOffice} onChange={(e) => { setForm({ ...form, "IDAttentionOffice": e }) }} label="Centro de Fabricación" />
                    </div>
                    <div className="col-md-6">
                        <SelectStoreEditor idSelector={form.IDStore} label="" onChange={(e) => { setForm({ ...form, "IDStore": e.IDStore }) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectProductionOrderStateConstants idSelector={form.State} onChange={(e) => { setForm({ ...form, "State": e }) }} label="Estado de la Orden de Producción" />
                    </div>
                    <div className="col-md-6 mt-4">
                        <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDRawMaterialRequest); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}